import { render, staticRenderFns } from "./totalDEF.vue?vue&type=template&id=d4b8b3a6&scoped=true&"
import script from "./totalDEF.vue?vue&type=script&lang=js&"
export * from "./totalDEF.vue?vue&type=script&lang=js&"
import style0 from "./totalDEF.vue?vue&type=style&index=0&id=d4b8b3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b8b3a6",
  null
  
)

export default component.exports